import { motion } from "framer-motion";
import { MessageSquareText } from "lucide-react";
import { WA_DEFAULT } from "./data";
import { scrollToId } from "@/lib/lenis";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function FloatingCta() {
  return (
    <>
      <motion.a
        href={WA_DEFAULT}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Lift Edge on WhatsApp"
        data-testid="floating-whatsapp-button"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.6, duration: 0.5 }}
        className="edge-glow fixed bottom-6 right-6 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-wa text-white transition-transform duration-200 hover:scale-110 md:flex"
      >
        <WhatsAppIcon className="h-7 w-7" />
      </motion.a>

      <div
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-px border-t border-white/10 bg-line md:hidden"
        data-testid="mobile-bottom-cta-bar"
      >
        <a
          href={WA_DEFAULT}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex items-center justify-center gap-2 bg-wa px-4 py-4 font-display text-base font-bold uppercase tracking-wider text-white"
        >
          <WhatsAppIcon className="h-5 w-5" />
          WhatsApp
        </a>
        <button
          onClick={() => scrollToId("#contact")}
          data-testid="mobile-bar-enquire"
          className="flex items-center justify-center gap-2 bg-edge px-4 py-4 font-display text-base font-bold uppercase tracking-wider text-white"
        >
          <MessageSquareText size={18} />
          Enquire Now
        </button>
      </div>
    </>
  );
}
